<script setup>
import { useLicenseStore } from '@/stores/license'

definePage({
  meta: {
    layout: 'default',
    action: 'manage',
    subject: 'License',
  },
})

const licenseStore = useLicenseStore()
const router = useRouter()

const form = ref({
  license_key: '',
  edition: 'standard',
})

const editionOptions = [
  { title: 'Standard', value: 'standard' },
  { title: 'Assistant (dengan AI)', value: 'assistant' },
]

const saving = ref(false)
const errors = ref({})

onMounted(() => {
  if (!licenseStore.status) licenseStore.fetchStatus()
})

const activate = async () => {
  saving.value = true
  errors.value = {}
  try {
    await licenseStore.activate(form.value)
    router.push({ name: 'dashboards' })
  } catch (e) {
    if (e?.status === 422) {
      errors.value = e?.data?.errors ?? {}
    } else {
      console.error('Aktivasi lisensi gagal:', e)
    }
  } finally {
    saving.value = false
  }
}
</script>

<template>
  <div
    class="d-flex align-center justify-center"
    style="min-height: 70vh;"
  >
    <VCard
      max-width="480"
      width="100%"
    >
      <VCardText class="pa-8">
        <div class="text-center mb-6">
          <VIcon
            icon="ri-shield-star-line"
            size="48"
            color="primary"
            class="mb-3"
          />
          <h4 class="text-h5 font-weight-bold">
            Aktivasi Lisensi QUALIVA
          </h4>
          <p class="text-body-2 text-medium-emphasis mb-0">
            Instalasi ini belum aktif. Masukkan license key untuk mulai memakai QUALIVA.
          </p>
        </div>

        <VAlert
          v-if="licenseStore.isActivated && !licenseStore.isValid"
          type="warning"
          variant="tonal"
          density="compact"
          class="mb-4"
        >
          Aktivasi sebelumnya tidak valid (kemungkinan data lisensi lokal rusak/diubah). Aktivasi ulang di bawah ini.
        </VAlert>

        <VForm @submit.prevent="activate">
          <VRow>
            <VCol cols="12">
              <VTextField
                v-model="form.license_key"
                label="License Key *"
                placeholder="ABCD-1234-EFGH-5678"
                :error-messages="errors.license_key"
                autofocus
              />
            </VCol>
            <VCol cols="12">
              <VSelect
                v-model="form.edition"
                :items="editionOptions"
                label="Edisi *"
                :error-messages="errors.edition"
              />
            </VCol>
            <VCol cols="12">
              <VBtn
                block
                type="submit"
                :loading="saving"
              >
                Aktivasi
              </VBtn>
            </VCol>
          </VRow>
        </VForm>
      </VCardText>
    </VCard>
  </div>
</template>
